export const CLIENT_LIB_VERSION = '2.4.0'
export const CLIENT_LIB_USER_AGENT = `influxdb3-js/${CLIENT_LIB_VERSION}`
